import React, {Component} from 'react'
import parse from 'html-react-parser';
import {getPagesBySlug} from '../../../services/reservoir'
import Loading from '../Loading'
import Error404 from '../../pages/errors/404'

export default class Page extends Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      content: null,
    }
  }

  componentDidMount() {
    this.loadResourceLandingPage()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.pageSlug !== this.props.match.params.pageSlug) {
      this.loadResourceLandingPage()
    }
  }

  loadResourceLandingPage = () => {
    this.setState({
      loading: true,
      content: null,
    })

    getPagesBySlug(this.props.match.params.pageSlug).then(({data = []}) => {
      this.setState({
        loading: false
      })

      if (data.length > 0) {
        this.setState({
          content: data[0].attributes && data[0].attributes.body && data[0].attributes.body.value
        })
      }
    })
  }

  render() {
    if (this.state.loading) {
      return <Loading/>
    }

    if (this.state.content !== null) {
      return <div>{parse(this.state.content)}</div>
    }

    return <Error404/>
  }
}
